import { Outlet, useNavigation } from "react-router-dom";

// import { useSelector } from 'react-redux';
import Footer from "../components/layout/Footer";
// import GuestNavigation from '../components/navigation/GuestNavigation';

// import { RootState } from '../store/indexRedux';
import Loading from "../components/ui/Loading";
import MainNavigation from "../components/navigation/MainNavigation";

function Root() {
  // const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);
  const navigation = useNavigation();
  return (
    <div className="flex flex-col min-h-screen antialiased">
      <div>
        {/* <div className='lg:mx-auto '> {isAuthenticated ? <MainNavigation /> : <GuestNavigation />}</div> */}
        <div className="lg:mx-auto ">
          <MainNavigation />{" "}
        </div>
      </div>
      <div className="bg-gray-50 dark:bg-primary-950 border-[1px] border-base-200 dark:border-primary-800 flex-grow">
        <div className="max-w-[1300px] lg:mx-auto mx-3 md:mx-10">
          {navigation.state === "loading" && <Loading />}
          <Outlet />
        </div>
      </div>
      <div className=" bg-gray-100 dark:bg-primary-900  border-gray-200 dark:border-primary-800 text-gray-500  dark:text-gray-200">
        <div className="max-w-[1300px] lg:mx-auto   mx-4 md:mx-10">
          <Footer />
        </div>
      </div>
    </div>
  );
}
export default Root;
